
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../services/apiClient';
import { GlobalProperties } from "../../config/config";
import { DEFAULT_UI_DICTIONARY, API_NAME_TO_UI_KEY_MAP } from '../../utils/Constants';


export const fetchAllLabels = createAsyncThunk(
    'labels/fetchAllLabels',
    async (_arg: any, { rejectWithValue }) => {
        try {
            // apiClient injects the current Access Token automatically (and
            // transparently refreshes it via the Public API if expired) -
            // see src/services/apiClient.ts / tokenManager.ts.
            const response = await apiClient.get(GlobalProperties);
            return response.data; // This returns the object containing GlobalProperties
        } catch (error: any) {
            return rejectWithValue(error.response?.data || "Error fetching labels");
        }
    }
);

const initialState = {
    labels: [],
    uiDictionary: { ...DEFAULT_UI_DICTIONARY } as Record<string, string>, // Use a copy of the constant
    labelloading: false,
    isLoaded: false,
    error: null,
};

const labelsSlice = createSlice({
    name: 'labels',
    initialState,
    reducers: {
        resetLabels: (state) => {
            state.uiDictionary = { ...DEFAULT_UI_DICTIONARY };
            state.isLoaded = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAllLabels.pending, (state) => {
                state.labelloading = true;
            })
            .addCase(fetchAllLabels.fulfilled, (state, action) => {
                state.labelloading = false;
                state.isLoaded = true;

                // FIX: Navigate to GlobalProperties specifically
                const properties = action.payload?.GlobalProperties || [];
                state.labels = properties;

                if (Array.isArray(properties)) {
                    properties.forEach((item: any) => {
                        // Use the imported constant map
                        const dictionaryKey =  (API_NAME_TO_UI_KEY_MAP as any)[item.Name];
                        
                        if (dictionaryKey && item.DisplayName) {
                            // This will now set state.uiDictionary["Tags"] = "Tag"
                            state.uiDictionary[dictionaryKey] = item.DisplayName;
                        }
                    });
                }
            })
            .addCase(fetchAllLabels.rejected, (state, action) => {
                state.labelloading = false;
                state.isLoaded = true;
                state.error = action.payload;
            });
    },
});

export const { resetLabels } = labelsSlice.actions;
export default labelsSlice.reducer;